module.exports = __webpack_public_path__ + "static/media/accessory__RTCSensor.3fb3b04b.jpg";